/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronTripleUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18.707 8.293 12 1.586 5.293 8.293l1.414 1.414L12 4.414l5.293 5.293zm0 6L12 7.586l-6.707 6.707 1.414 1.414L12 10.414l5.293 5.293zm0 6L12 13.586l-6.707 6.707 1.414 1.414L12 16.414l5.293 5.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChevronTripleUp as ChevronTripleUp };
